import { ENVIRONMENTS } from 'constants-activate';

import baseConfig from './services/config.json';
import { appUrl } from './utilities/getAppUrl';
import { getEnv } from './utilities/environment';

type AvailableEnvironments = keyof typeof baseConfig;

const env = getEnv();

const configEnv = env === ENVIRONMENTS.PREVIEW ? ENVIRONMENTS.DEVELOPMENT : env;

const config = {
  ...baseConfig.default,
  ...baseConfig[configEnv as AvailableEnvironments],
};

if (
  [ENVIRONMENTS.LOCAL, ENVIRONMENTS.TEST].includes(
    process.env.APP_ENV as ENVIRONMENTS
  )
) {
  if (process.env.LD_CLIENT_ID) {
    config.launchDarkly.clientId = process.env.LD_CLIENT_ID;
  }

  if (process.env.LD_MOBILE_ID) {
    config.launchDarkly.mobileId = process.env.LD_MOBILE_ID;
  }

  if (process.env.AWS_REGION) {
    config.aws_region = process.env.AWS_REGION;
  }

  if (process.env.AUTH0_DOMAIN) {
    config.auth0.domain = process.env.AUTH0_DOMAIN;
  }

  if (process.env.AUTH0_CLIENT_ID) {
    config.auth0.clientId = process.env.AUTH0_CLIENT_ID;
  }

  if (process.env.GET_STREAM_API_KEY) {
    config.getStream.apiKey = process.env.GET_STREAM_API_KEY;
  }
}

if (process.env.GITHUB_SHA_SHORT) {
  config.mobileVersion.githubSha1 = process.env.GITHUB_SHA_SHORT;
}

if (env !== 'test')
  console.log(
    `[config] Using APP_ENV="${env}" appUrl="${appUrl}" aws_region="${config.aws_region}" redirect_service="${process.env.USE_AUTH0_REDIRECT_SERVICE}"`
  );

const region: keyof typeof config.s3 =
  (config?.aws_region as keyof typeof config.s3) ?? 'us-east-2';

const s3Region: Record<string, any> = config?.s3?.[region] ?? {};

export const AmazonS3Buckets = {
  Lane: s3Region?.mediaBucket,
  Activate: s3Region?.privateMediaBucket ?? s3Region?.mediaBucket,
  EssensysReports: s3Region?.essensysReports,
  IntegrationGateway: s3Region?.integrationsGateway,
  VisitorManagementAppleWalletPasses:
    s3Region?.visitorManagementAppleWalletPasses,
};

export { config };
